import { useTheme } from 'styled-components'

import { Chip, Text } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const PidLabel = ({ label, pid }) => {
  const theme = useTheme()

  return (
    <Styles.Container>
      {label}{' '}
      <Chip
        backgroundColor={theme.colors.info.surface}
        color={theme.colors.info.onSurface}
        label={
          <Text type="bodyMonospaced" tag="span" color={theme.colors.info.onSurface}>
            {pid}
          </Text>
        }
      />
    </Styles.Container>
  )
}

export default PidLabel
